import { styled } from "goober";
import { formatTinesUnits } from "../../lib/formatTinesUnits";
import { Text } from "../Text";
import { Tooltip } from "../Tooltip";
import { USAGE_FILL } from "./tinesUnitsStatus";

const Cell = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
  min-width: 0;
`;

const Figures = styled("div")`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

// Fixed to the hovered height so the bar can grow without shifting the row.
const TrackSlot = styled("div")`
  display: flex;
  align-items: center;
  width: 100%;
  height: 9px;

  &:hover > * {
    height: 9px;
  }
`;

const Track = styled("div")`
  display: flex;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--alpha8);
  transition: height var(--motion-fast) var(--ease-out);
`;

const Used = styled("div")`
  background: ${USAGE_FILL.ok};
`;

const Forecast = styled("div")`
  background: color-mix(in srgb, ${USAGE_FILL.ok} 30%, transparent);
`;

// Rows in one list share `max` so their bars compare.
export function TinesUnitsForecastBar({
  used,
  forecast,
  max,
}: {
  used: number;
  forecast: number;
  max: number;
}) {
  const percent = (units: number) =>
    `${Math.min(100, max > 0 ? (units / max) * 100 : 0)}%`;
  return (
    <Tooltip
      fill="stretch"
      content={`${formatTinesUnits(used)} used so far, about ${formatTinesUnits(forecast)} by month end.`}
    >
      <Cell>
        <Figures>
          <Text variant="text-small-md">{formatTinesUnits(used)}</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            → {formatTinesUnits(forecast)}
          </Text>
        </Figures>
        <TrackSlot>
          <Track aria-hidden>
            <Used style={{ width: percent(used) }} />
            <Forecast
              style={{ width: percent(Math.max(0, forecast - used)) }}
            />
          </Track>
        </TrackSlot>
      </Cell>
    </Tooltip>
  );
}
